import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformer from '../transformers';
const rootPath = 'members';
export const fromRaw = ({ id, created_at, email, name, organization, role }) => ({
    id,
    creationDate: created_at,
    email,
    name,
    orgId: organization,
    role
});
const members = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: `${rootPath}`,
        requestCtx: {
            params: {
                query: {
                    organization: query?.orgId,
                    offset: query?.offset,
                    limit: query?.limit,
                    q: query?.q,
                    role: query?.roles,
                    sort_by: query?.sortBy,
                    sort_order: query?.sortOrder
                }
            },
            transform: transformer.paginatedResponse(fromRaw)
        }
    });
    const getCSV = (organizationId) => requesterBuilder({
        path: `${rootPath}/export`,
        requestCtx: {
            method: 'GET',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            parse: (x) => x.blob(),
            transform: (blob) => blob,
            params: {
                query: {
                    organization: organizationId
                }
            }
        }
    });
    const buildKeysToInvalidate = () => [getMany().invalidationKey];
    return {
        get: methods.get({ requesterBuilder, rootPath, fromRaw }),
        getMany,
        getPage: methods.getPage({ getMany }),
        updateRole: (memberId) => requesterBuilder({
            path: `${rootPath}/${memberId}/change_role`,
            requestCtx: {
                method: 'POST',
                toRaw: (value) => value,
                transform: fromRaw
            },
            keysToInvalidate: buildKeysToInvalidate()
        }),
        deletion: methods.deletion({ rootPath, requesterBuilder, buildKeysToInvalidate }),
        download: getCSV
    };
});
export default members;
